export default __webpack_public_path__ + "static/media/Othmane-El-Mounir-CV.f7b6d1bc.pdf";